import {ITargetAccount} from "../domain/accounts/ITargetAccount";
import {ETargetAccountType} from "../enums/ETargetAccountType";

export class TargetAccountEntity implements ITargetAccount {
  accountNumber: string;
  firstName: string;
  id: number;
  lastName: string;
  alias: string;
  email: string;
  type: ETargetAccountType;
  institution: string;
  institutionId: string;
  frequent: boolean;

  constructor() {
    this.accountNumber = null;
    this.firstName = null;
    this.id = null;
    this.lastName = null;
    this.alias = null;
    this.type = null;
    this.email = null;
    this.institution = 'The Alterna Sin Fronteras Card';
    this.institutionId = '00000';
    this.frequent = false;
  }


}